module.exports = __webpack_public_path__ + "static/media/general-de-seguros-star.0de6e72a.svg";